import React from "react"
import { MainCP } from "../../Components/imagen-positiva-rostro-publicitario-2024/MainCP"

const ViewImagenPositivaRostroPublicitario2024: React.FC = () => <MainCP/>

export default ViewImagenPositivaRostroPublicitario2024